import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const setPieceTakersStyles = style({
  display: "grid",
  gap: vars.space.m,
});

export const noteList = style({
  marginTop: vars.space.s,
  paddingInlineStart: vars.space.m,
});

export const noteItem = style({
  listStyleType: "disc",
  selectors: {
    "&:not(:last-child)": {
      marginBlockEnd: vars.space.m,
    },
  },
});

export const noteLink = style({
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  color: vars.colors.onSurface,
  ":hover": {
    textDecoration: "underline",
  },
});

export const teamContentInner = style({
  display: "grid",
  gap: vars.space.m,
  padding: vars.space.m,
});

export const setPieceTitle = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading.m,
});

export const elementStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
  marginTop: vars.space.s,
});

export const setPieceTakersWrapper = style({
  display: "grid",
  gap: vars.space.xs,
});

// TODO: fix this
export const disclosureHeading = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

export const teamDetails = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.s,
});

export const badgeWrap = style({
  width: "4.8rem",
  height: "4.8rem",
});

export const teamName = style({
  fontSize: vars.fontSizes.heading.m,
});

export const chevronDown = style({
  transformOrigin: "center",
  transition: "transform 0.2s",
  width: 20,
  height: 20,
  fill: vars.colors.onSurface,
  selectors: {
    '[data-expanded="true"] &': {
      transform: "rotate(-180deg)",
    },
  },
});

export const explainedSection = style({
  display: "grid",
  gap: vars.space.m,
});
